const columns = [
    { id: 'id', label: 'ID'},
    { id: 'jackpot', label: 'Джекпот'},
    { id: 'status', label: 'Статус'},
    { id: 'groups', label: 'Группа'},
    { id: 'primary_amount', label: 'Осн. джекпот'},
    // { id: 'primary_storage', label: 'Перв. накопление джекпота'},
    { id: 'secondary_amount', label: 'Втор. джекпот'},
    // { id: 'secondary_storage', label: 'Втор. накопление джекпота'},
    // { id: 'min_win', label: 'Мин. Сумма выигрыша'},
    // { id: 'max_win', label: 'Макс. Сумма выигрыша'},
    // { id: 'min_bet', label: 'Мин. ставка'},
    // { id: 'max_bet', label: 'Макс. ставка'},
    { id: 'give', label: 'Инфо'}
];

const getRows = (list) => {
    return list.map((item) => {
        return {
            id: item.id,
            jackpot: item.jackpot,
            status: item.status ? 'Включен' : 'Выключен',
            groups: item.groups,
            primary_amount: new Intl.NumberFormat('ru-RU').format(item.primary_amount) + '₽',
            // primary_storage: item.primary_storage,
            secondary_amount: new Intl.NumberFormat('ru-RU').format(item.secondary_amount) + '₽',
            // secondary_storage: item.secondary_storage,
            // min_win: item.min_win,
            // max_win: item.max_win,
            // min_bet: item.min_bet,
            // max_bet: item.max_bet
        }
    }); 
} 


export {
    columns,
    getRows
}